// @flow

//
// Trix Middleware
//
import { get } from '../../lib/trix-web-middleware-commons';

//
// Name
//
import { PLUGIN_NAME } from './plugin';

//
// Components
//
import { components } from './web';

//
// Plugin Definition
//
const plugin = {
    name: PLUGIN_NAME,

    //
    // State
    //
    state: {
    },

    //
    // Boot functions
    //
    boot: {
        load: (tenantId: number, reject: (error: any) => void, resolve: (data: any) => void) => {
            get(
                // url
                '/api/v1/wms/settings/index', 

                // options
                {
                    headers: {
                        // On server disable X-Tenant header for 'index' request (index is same for all tenants)
                        'X-Tenant': 0
                    }
                },

                // reject callback
                reject, 

                // resolve callback
                (data) => resolve(data.body)
            );
        },
    },

    //
    // Web
    //
    web: {
        // public components
        components
    },
}
export default plugin;